import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {ALL_MEASUREMENT_TYPES, getMeasurementTypeLocalizationKey, MeasurementType} from "../../../measurement-models";
import {localizationKey} from "../../../../i18n/i18n-model";
import {ReleaseToggleState} from "../../../../tools/release-toggles/release-toggle-state";
import {AllowedHospitalMeasurementTypes} from "../hospital.details";

@Component({
    selector: "app-allowed-types-section",
    templateUrl: "./allowed-types-section.component.html",
    styleUrls: ["./allowed-types-section.component.css"],
    standalone: false
})
export class AllowedTypesSectionComponent implements OnInit {

  @Input() initialAllowedMeasurementTypes!: AllowedHospitalMeasurementTypes;

  @Output() typesChanged = new EventEmitter<AllowedHospitalMeasurementTypes>();

  allMeasurementTypes: MeasurementType[] = ALL_MEASUREMENT_TYPES.map(it => it);
  feature311Released = ReleaseToggleState.getInstance().isReleased("ENABLE_HOME_MEASUREMENT_TYPES_311");

  protected readonly localizationKey = localizationKey;
  protected readonly getMeasurementTypeLocalizationKey = getMeasurementTypeLocalizationKey;

  allowedTypes: Record<MeasurementType, boolean> = {} as Record<MeasurementType, boolean>;
  allowedHomeTypes: Record<MeasurementType, boolean> = {} as Record<MeasurementType, boolean>;

  ngOnInit(): void {
    ALL_MEASUREMENT_TYPES
      .forEach(type => {
        this.allowedTypes[type] = this.initialAllowedMeasurementTypes.types.includes(type);
        this.allowedHomeTypes[type] = this.initialAllowedMeasurementTypes.homeTypes.includes(type);
      });
  }

  onTypeChange(type: MeasurementType, value: boolean) {
    this.allowedTypes[type] = value;
    this.emitTypes();
  }

  onHomeTypeChange(type: MeasurementType, value: boolean) {
    this.allowedHomeTypes[type] = value;
    this.emitTypes();
  }

  private emitTypes() {
    this.typesChanged.emit({
      types: ALL_MEASUREMENT_TYPES.filter(type => this.allowedTypes[type]),
      homeTypes: ALL_MEASUREMENT_TYPES.filter(type => this.allowedHomeTypes[type])
    });
  }
}
